import useRouter from 'common/hooks/use-router';
import useItem from 'common/hooks/useItem';
import React, { useCallback, useContext, useEffect } from 'react';
import { useTranslation } from 'react-i18next';

import AlertsContext from 'common/providers/alerts';
import EstablishmentForm from './EstablishmentForm';

function Establishment() {
  const { t } = useTranslation();
  const router = useRouter();
  const { setAlert } = useContext(AlertsContext);

  const id = router.query.id as string;

  const { saveItem, updateItem, item, error, isFetching }: any = useItem('establishments', id, {
    populate: ['department', 'referentOperators', 'referentOperators.user'],
  });

  useEffect(() => {
    if (error) {
      setAlert(error, 'danger');
    }
  }, [error, setAlert]);

  const back = useCallback(() => {
    if (!error) {
      setAlert(t('common.saved'), 'success');
      router.navigate('/establishments');
    }
  }, [setAlert, router, error, t]);

  const onSubmit = useCallback(
    async (dataEstablishment: any) => {
      const establishment = { ...dataEstablishment };

      try {
        if (establishment.id) {
          await updateItem(establishment.id, establishment);
        } else {
          await saveItem(establishment);
        }
      } catch (e: any) {
        return e;
      }

      back();
      return true;
    },
    [updateItem, back, saveItem]
  );

  return isFetching || (id && !item) ? null : (
    <EstablishmentForm onSubmit={onSubmit} establishment={item} />
  );
}

export default Establishment;
